import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How long does a typical PC tune-up take?",
    a: "Most tune-ups are completed the same day — usually within 2–4 hours. For deep malware removal or hardware upgrades, we'll give you an exact time estimate during diagnostics.",
  },
  {
    q: "Will I lose any of my files?",
    a: "No. Before any significant work, we image your drive or back up critical data. You approve every step before we proceed.",
  },
  {
    q: "Do you offer a warranty on repairs?",
    a: "Yes. All tune-ups and virus removals come with a 30-day satisfaction guarantee. Hardware repairs carry a 90-day parts & labor warranty.",
  },
  {
    q: "Can you help remotely, or do I need to bring my PC in?",
    a: "Both! Most software issues are solved faster via our secure remote support. For hardware issues, we offer free pickup & delivery within our service area.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Credit & debit cards, Apple Pay, Google Pay, bank transfer, and for business clients — invoiced Net-15 terms.",
  },
  {
    q: "Do you support Mac and Linux as well as Windows?",
    a: "Yes. Our technicians are certified across Windows 10/11, macOS (Intel & Apple Silicon), and major Linux distributions.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-zinc-50 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-sm font-semibold uppercase tracking-widest text-blue-600">FAQ</div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">
            Questions we hear a lot.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-zinc-200 rounded-xl px-6"
            >
              <AccordionTrigger className="text-left font-heading text-base md:text-lg font-semibold text-zinc-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-600 text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
